import formatGetUrl from './formatGetUrl';
export function ajax(config) {
    const Authorization = typeof localStorage !== 'undefined' && localStorage.getItem('sso_token');
    if (Authorization) {
        config.headers = {
            Authorization,
        };
    }
    let method = config.method ? config.method.toUpperCase() : 'GET';
    let customConfig = {};
    let url;
    let headers = Object.assign({}, config.headers);
    if (method === 'GET') {
        url = formatGetUrl(config.url, config.data);
    }
    else {
        url = config.url;
        customConfig.body = JSON.stringify(config.data);
    }
    // Remove config properties that are formatted by this function
    delete config.url;
    delete config.data;
    delete config.method;
    delete config.headers;
    return fetch(url, Object.assign(Object.assign({ method, credentials: 'same-origin', headers: new Headers(Object.assign({ 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, headers)) }, customConfig), config));
}
